import { useState } from 'react';
import Sidebar from './sidebar';
import Topbar from './topbar';

interface DashboardLayoutProps {
  children: React.ReactNode;
}

export default function DashboardLayout({ children }: DashboardLayoutProps) {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);

  return (
    <div className="qf-app-shell min-h-screen overflow-x-hidden transition-colors duration-200">
      <a
        className="fixed left-4 top-3 z-50 -translate-y-20 rounded-md bg-[#7AD8CC] px-3 py-2 text-sm font-semibold text-[#0B1114] focus:translate-y-0"
        href="#main-content"
      >
        Skip to content
      </a>
      <Sidebar
        collapsed={sidebarCollapsed}
        onToggle={() => setSidebarCollapsed(!sidebarCollapsed)}
        mobileOpen={mobileSidebarOpen}
        onMobileClose={() => setMobileSidebarOpen(false)}
      />
      <main
        id="main-content"
        className={`${
          sidebarCollapsed ? 'md:ml-20' : 'md:ml-72'
        } min-h-screen transition-all duration-300`}
      >
        <Topbar onMobileMenuClick={() => setMobileSidebarOpen(true)} />
        <div className="page-transition">{children}</div>
      </main>
    </div>
  );
}
